import { IColorInputControl } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../../infrastructure/providers/abstract/IApiProvider';
import {
  ColorInputFormControlViewModel,
  FormControlViewModelType,
  LocalizedProps,
} from '../../view-model/FormControlViewModel';
import { FormSource, FormSourceType } from '../../view-model/FormSource';

import { getValueFromArgsOrConfig } from './helpers';

const buildColorInputControl = (
  item: IColorInputControl,
  localizedProps: LocalizedProps,
  args: TActionArgsValues,
  source: FormSource
): ColorInputFormControlViewModel => ({
  type: FormControlViewModelType.COLOR_INPUT,
  value: getValueFromArgsOrConfig<number | null>(item, args, source, null),
  canClearOnReadOnly: true,
  columns: item.columns,
  name: item.name,
  disabled: item.disabled,
  enableButtonOnReadOnly: source.type !== FormSourceType.REVIEW,
  noLabel: item.noLabel,
  required: item.required,
  storeValue: item.storeValue,
  readonly: item.readonly || source.type === FormSourceType.REVIEW,
  hasValue: true,
  hasHistory: false,
  visible: item.visible,
  ...localizedProps,
});

export default buildColorInputControl;
